// Copyright (c) 2016 Deere & Company

export const isDaysToDisplayValid = days =>
    days > 0 && days < 10000;



// WEBPACK FOOTER //
// ./src/user/shared/validations/days-to-display.js